import type { TextMaterialTheme } from '@@partner:types:app'

import React from 'react'
import {
  formatDate
} from '@@partner:helpers/util'

import { Link, generatePath } from 'react-router-dom'
import { Button, ButtonGroup, Table, Tag } from 'rsuite'
import AppLoader from '@components/common/AppLoader'

import {
  ROUTE_TEXT_MATERIALS_CATEGORIES_EDIT,
  ROUTE_TEXT_MATERIALS_THEMES,
  ROUTE_TEXT_MATERIALS_THEMES_EDIT
} from '@@partner:config/routes'
import TextMaterialThemeStatusLabel from '../common/TextMaterialThemeStatusLabel'

const Column = Table.Column
const HeaderCell = Table.HeaderCell
const Cell = Table.Cell

export interface TextMaterialThemesTableProps {
  brandSlug: string
  textMaterialThemes: TextMaterialTheme[]
  loading?: boolean
}

export default function TextMaterialThemesTable ({
  brandSlug,
  textMaterialThemes = [],
  loading = false
}: TextMaterialThemesTableProps) {

  return (
    <Table
      data={textMaterialThemes}
      autoHeight
      wordWrap
      loading={loading}
      renderLoading={() =>
        loading ? <AppLoader.Inner content="Загрузка таблицы" /> : null
      }
      affixHeader
      rowHeight={120}
      className="TextMaterialThemesTable"
    >
      <Column sortable flexGrow={1} verticalAlign="middle">
        <HeaderCell>ID</HeaderCell>
        <Cell dataKey="id"></Cell>
      </Column>
      <Column flexGrow={3} verticalAlign="middle">
        <HeaderCell>Название</HeaderCell>
        <Cell dataKey="name"></Cell>
      </Column>
      <Column sortable flexGrow={3} verticalAlign="middle">
        <HeaderCell>Статус</HeaderCell>
        <Cell dataKey="status">
          {(theme: TextMaterialTheme) => (
            <>
              <TextMaterialThemeStatusLabel status={theme.status} />
            </>
          )}
        </Cell>
      </Column>
      <Column flexGrow={3} verticalAlign="middle">
        <HeaderCell>Заголовок</HeaderCell>
        <Cell dataKey="title">
          {(theme: TextMaterialTheme) => (
            <div>
              { theme?.i18n?.map(translation => (
                <div key={translation.languageCode}>
                  {translation.languageCode}: {translation.title}
                </div>
              ))}
            </div>
          )}
        </Cell>
      </Column>
      <Column sortable flexGrow={3} verticalAlign="middle">
        <HeaderCell>Создан</HeaderCell>
        <Cell dataKey="created_at">
          {(theme: TextMaterialTheme) => (
            <Tag color="blue">{formatDate(new Date(theme.created_at))}</Tag>
          )}
        </Cell>
      </Column>
      <Column sortable flexGrow={3} verticalAlign="middle">
        <HeaderCell>Обновлен</HeaderCell>
        <Cell dataKey="updated_at">
          {(theme: TextMaterialTheme) => (
            <Tag color="blue">{formatDate(new Date(theme.updated_at))}</Tag>
          )}
        </Cell>
      </Column>

      <Column flexGrow={4} fixed="right" verticalAlign="middle">
        <HeaderCell>Управление</HeaderCell>
        <Cell>
          {(theme: TextMaterialTheme) => (
            <ButtonGroup>
              <Button
                color="cyan"
                appearance="primary"
                as={Link}
                to={generatePath(ROUTE_TEXT_MATERIALS_THEMES_EDIT, {
                  brandSlug,
                  themeId: theme.id
                })}
                size="xs"
              >
                Изменить
              </Button>
            </ButtonGroup>
          )}
        </Cell>
      </Column>
    </Table>
  )
}
